module.exports = __webpack_public_path__ + "static/media/3.a76bd251.jpg";